import { trpc } from '@tencent/tpro_rmonitor_ai_server_agent';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { logger } from '@/infrastructure/logger';
import { WithTypeCast } from '@raft/utils';
import { TrpcService } from './trpc';

export type IAddAgentReq = WithTypeCast<trpc.rmonitor.ai_server.IAddAgentReq>;
export type IAddAgentRsp = WithTypeCast<trpc.rmonitor.ai_server.IAddAgentRsp>;
export type IGetAgentReq = WithTypeCast<trpc.rmonitor.ai_server.IGetAgentReq>;
export type IGetAgentRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetAgentRsp>;
export type IUpdateAgentReq = WithTypeCast<trpc.rmonitor.ai_server.IUpdateAgentReq>;
export type IUpdateAgentRsp = WithTypeCast<trpc.rmonitor.ai_server.IUpdateAgentRsp>;
export type IDeleteAgentReq = WithTypeCast<trpc.rmonitor.ai_server.IDeleteAgentReq>;
export type IDeleteAgentRsp = WithTypeCast<trpc.rmonitor.ai_server.IDeleteAgentRsp>;

export type IGetDatasByUserReq = WithTypeCast<trpc.rmonitor.ai_server.IGetDatasByUserReq>;
export type IGetAgentsByUserRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetAgentsByUserRsp>;
export type IGetMcpsByUserRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetMcpsByUserRsp>;
export type IGetSkillsByUserRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetSkillsByUserRsp>;
export type IGetToolsRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetToolsRsp>;
export type IGetRulesByUserRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetRulesByUserRsp>;
export type IDeleteRulesReq = WithTypeCast<trpc.rmonitor.ai_server.IDeleteRulesReq>;
export type IDeleteRulesRsp = WithTypeCast<trpc.rmonitor.ai_server.IDeleteRulesRsp>;

export type IGetUploadURLReq = WithTypeCast<trpc.rmonitor.ai_server.IGetUploadURLReq>;
export type IGetUploadURLRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetUploadURLRsp>;

export type IAddMcpReq = WithTypeCast<trpc.rmonitor.ai_server.IAddMcpReq>;
export type IAddMcpRsp = WithTypeCast<trpc.rmonitor.ai_server.IAddMcpRsp>;
export type IGetMcpReq = WithTypeCast<trpc.rmonitor.ai_server.IGetMcpReq>;
export type IGetMcpRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetMcpRsp>;
export type IUpdateMcpReq = WithTypeCast<trpc.rmonitor.ai_server.IUpdateMcpReq>;
export type IUpdateMcpRsp = WithTypeCast<trpc.rmonitor.ai_server.IUpdateMcpRsp>;

export type IAddSkillReq = WithTypeCast<trpc.rmonitor.ai_server.IAddSkillReq>;
export type IAddSkillRsp = WithTypeCast<trpc.rmonitor.ai_server.IAddSkillRsp>;
export type IGetSkillReq = WithTypeCast<trpc.rmonitor.ai_server.IGetSkillReq>;
export type IGetSkillRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetSkillRsp>;
export type IUpdateSkillReq = WithTypeCast<trpc.rmonitor.ai_server.IUpdateSkillReq>;
export type IUpdateSkillRsp = WithTypeCast<trpc.rmonitor.ai_server.IUpdateSkillRsp>;

export type IAddRulesReq = WithTypeCast<trpc.rmonitor.ai_server.IAddRulesReq>;
export type IAddRulesRsp = WithTypeCast<trpc.rmonitor.ai_server.IAddRulesRsp>;
export type IGetRulesReq = WithTypeCast<trpc.rmonitor.ai_server.IGetRulesReq>;
export type IGetRulesRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetRulesRsp>;
export type IUpdateRulesReq = WithTypeCast<trpc.rmonitor.ai_server.IUpdateRulesReq>;
export type IUpdateRulesRsp = WithTypeCast<trpc.rmonitor.ai_server.IUpdateRulesRsp>;

export type IAddKnowledgeReq = WithTypeCast<trpc.rmonitor.ai_server.IAddKnowledgeReq>;
export type IAddKnowledgeRsp = WithTypeCast<trpc.rmonitor.ai_server.IAddKnowledgeRsp>;
export type IListKnowLedgesReq = WithTypeCast<trpc.rmonitor.ai_server.IListKnowLedgesReq>;
export type IListKnowLedgesRsp = WithTypeCast<trpc.rmonitor.ai_server.IListKnowLedgesRsp>;
export type IDeleteKnowledgeReq = WithTypeCast<trpc.rmonitor.ai_server.IDeleteKnowledgeReq>;
export type IDeleteKnowledgeRsp = WithTypeCast<trpc.rmonitor.ai_server.IDeleteKnowledgeRsp>;
export type IGetKnowledgeReq = WithTypeCast<trpc.rmonitor.ai_server.IGetKnowledgeReq>;
export type IGetKnowledgeRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetKnowledgeRsp>;
export type IDocumentInfo = WithTypeCast<trpc.rmonitor.ai_server.IDocumentInfo>;
export type ISearchChunk = WithTypeCast<trpc.rmonitor.ai_server.ISearchChunk>;
export type IUpdateKnowledgeReq = WithTypeCast<trpc.rmonitor.ai_server.IUpdateKnowledgeReq>;
export type IUpdateKnowledgeRsp = WithTypeCast<trpc.rmonitor.ai_server.IUpdateKnowledgeRsp>;

export type IUpdateDocumentReq = WithTypeCast<trpc.rmonitor.ai_server.IUpdateDocumentReq>;
export type IUpdateDocumentRsp = WithTypeCast<trpc.rmonitor.ai_server.IUpdateDocumentRsp>;

export type IAddDocumentReq = WithTypeCast<trpc.rmonitor.ai_server.IAddDocumentReq>;
export type IAddDocumentRsp = WithTypeCast<trpc.rmonitor.ai_server.IAddDocumentRsp>;
export type IDeleteDocumentReq = WithTypeCast<trpc.rmonitor.ai_server.IDeleteDocumentReq>;
export type IDeleteDocumentRsp = WithTypeCast<trpc.rmonitor.ai_server.IDeleteDocumentRsp>;
export type ISearchDocumentsReq = WithTypeCast<trpc.rmonitor.ai_server.ISearchDocumentsReq>;
export type ISearchDocumentsRsp = WithTypeCast<trpc.rmonitor.ai_server.ISearchDocumentsRsp>;

export type IAgentInfo = WithTypeCast<trpc.rmonitor.ai_server.IAgentInfo>;
export type IMcpInfo = WithTypeCast<trpc.rmonitor.ai_server.IMcpInfo>;
export type IKnowledgeInfo = WithTypeCast<trpc.rmonitor.ai_server.IKnowledgeInfo>;
export type IRulesInfo = WithTypeCast<trpc.rmonitor.ai_server.IRulesInfo>;
export type IFile = WithTypeCast<trpc.rmonitor.ai_server.IFile>;

export const enum VisibleControl {
  PRIVATE = 0,
  PUBLIC = 1,
  PRODUCT = 2,
}

export const enum McpType {
  SSE = 0,
  STREAMABLES_HTTP = 1,
}

export const enum DocumentType {
  DOCUMENT_TYPE_UNKNOWN = 0,
  DOCUMENT_TYPE_IWIKI = 1,
  DOCUMENT_TYPE_MARKDOWN = 2
}


class AiAgentServer extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.AgentService,
    });
  }

  /** 新增智能体 */
  public async addAgent(req: IAddAgentReq): Promise<IAddAgentRsp> {
    try {
      return await this.trpcPost<IAddAgentRsp>('AddAgent', req);
    } catch (e) {
      logger.error('addAgent e:', e);
      return {};
    }
  }

  /** 获取智能体 */
  public async getAgent(req: IGetAgentReq): Promise<IGetAgentRsp> {
    try {
      return await this.trpcPost<IGetAgentRsp>('GetAgent', req);
    } catch (e) {
      logger.error('getAgent e:', e);
      return {};
    }
  }

  /** 更新智能体 */
  public async updateAgent(req: IUpdateAgentReq): Promise<IUpdateAgentRsp> {
    try {
      return await this.trpcPost<IUpdateAgentRsp>('UpdateAgent', req);
    } catch (e) {
      logger.error('updateAgent e:', e);
      return {};
    }
  }

  /** 删除智能体 */
  public async deleteAgent(req: IDeleteAgentReq): Promise<IDeleteAgentRsp> {
    try {
      return await this.trpcPost<IDeleteAgentRsp>('DeleteAgent', req);
    } catch (e) {
      logger.error('deleteAgent e:', e);
      return {};
    }
  }

  /** 获取用户下的智能体列表 */
  public async getAgentsByUser(req: IGetDatasByUserReq): Promise<IGetAgentsByUserRsp> {
    try {
      return await this.trpcPost<IGetAgentsByUserRsp>('GetAgentsByUser', req);
    } catch (e) {
      logger.error('getAgentsByUser e:', e);
      return {};
    }
  }

  /** 新增 MCP */
  public async addMcp(req: IAddMcpReq): Promise<boolean> {
    try {
      const rsp = await this.trpcPost<IAddMcpRsp>('AddMcp', req);
      return rsp?.baseRsp?.code === 0;
    } catch (e) {
      logger.error('addMcp e:', e);
      return false;
    }
  }

  /** 获取 MCP */
  public async getMcp(req: IGetMcpReq): Promise<IGetMcpRsp> {
    try {
      return await this.trpcPost<IGetMcpRsp>('GetMcp', req);
    } catch (e) {
      logger.error('getMcp e:', e);
      return {};
    }
  }

  /** 更新 MCP */
  public async updateMcp(req: IUpdateMcpReq): Promise<boolean> {
    try {
      const rsp = await this.trpcPost<IUpdateMcpRsp>('UpdateMcp', req);
      return rsp?.baseRsp?.code === 0;
    } catch (e) {
      logger.error('updateMcp e:', e);
      return false;
    }
  }

  /** 获取用户下的 MCP 列表 */
  public async getMcpsByUser(req: IGetDatasByUserReq): Promise<IMcpInfo[]> {
    try {
      const rsp = await this.trpcPost<IGetMcpsByUserRsp>('GetMcpsByUser', req);
      return rsp?.mcpInfos || [];
    } catch (e) {
      logger.error('getMcpsByUser e:', e);
      return [];
    }
  }

  /** 新增技能 */
  public async addSkill(req: IAddSkillReq): Promise<IAddSkillRsp> {
    try {
      return await this.trpcPost<IAddSkillRsp>('AddSkill', req);
    } catch (e) {
      logger.error('addSkill e:', e);
      return {};
    }
  }

  /** 获取技能 */
  public async getSkill(req: IGetSkillReq): Promise<IGetSkillRsp> {
    try {
      return await this.trpcPost<IGetSkillRsp>('GetSkill', req);
    } catch (e) {
      logger.error('getSkill e:', e);
      return {};
    }
  }

  /** 更新技能 */
  public async updateSkill(req: IUpdateSkillReq): Promise<IUpdateSkillRsp> {
    try {
      return await this.trpcPost<IUpdateSkillRsp>('UpdateSkill', req);
    } catch (e) {
      logger.error('updateSkill e:', e);
      return {};
    }
  }

  /** 获取用户下的技能列表 */
  public async getSkillsByUser(req: IGetDatasByUserReq): Promise<IGetSkillsByUserRsp> {
    try {
      return await this.trpcPost<IGetSkillsByUserRsp>('GetSkillsByUser', req);
    } catch (e) {
      logger.error('getSkillsByUser e:', e);
      return {};
    }
  }

  /** 获取工具列表 */
  public async getTools(req: IGetDatasByUserReq): Promise<IGetToolsRsp> {
    try {
      return await this.trpcPost<IGetToolsRsp>('GetTools', req);
    } catch (e) {
      logger.error('getTools e:', e);
      return {};
    }
  }

  /** 新增规则 */
  public async addRules(req: IAddRulesReq): Promise<IAddRulesRsp> {
    try {
      return await this.trpcPost<IAddRulesRsp>('AddRules', req);
    } catch (e) {
      logger.error('addRules e:', e);
      return {};
    }
  }

  /** 获取规则 */
  public async getRules(req: IGetRulesReq): Promise<IGetRulesRsp> {
    try {
      return await this.trpcPost<IGetRulesRsp>('GetRules', req);
    } catch (e) {
      logger.error('getRules e:', e);
      return {};
    }
  }

  /** 更新规则 */
  public async updateRules(req: IUpdateRulesReq): Promise<IUpdateRulesRsp> {
    try {
      return await this.trpcPost<IUpdateRulesRsp>('UpdateRules', req);
    } catch (e) {
      logger.error('updateRules e:', e);
      return {};
    }
  }

  /** 获取用户下的规则列表 */
  public async getRulesByUser(req: IGetDatasByUserReq): Promise<IGetRulesByUserRsp> {
    try {
      return await this.trpcPost<IGetRulesByUserRsp>('GetRulesByUser', req);
    } catch (e) {
      logger.error('getRulesByUser e:', e);
      return {};
    }
  }

  /** 删除rules */
  public async deleteRules(req: IDeleteRulesReq): Promise<IDeleteRulesRsp> {
    try {
      return await this.trpcPost<IDeleteRulesRsp>('DeleteRules', req);
    } catch (e) {
      logger.error('DeleteRules e:', e);
      return {};
    }
  }

  /** 新增知识库 */
  public async addKnowledge(req: IAddKnowledgeReq): Promise<IAddKnowledgeRsp> {
    try {
      return await this.trpcPost<IAddKnowledgeRsp>('AddKnowledge', req);
    } catch (e) {
      logger.error('addKnowledge e:', e);
      return {};
    }
  }

  /** 获取知识库列表 */
  public async listKnowLedges(req: IListKnowLedgesReq): Promise<IListKnowLedgesRsp> {
    try {
      return await this.trpcPost<IListKnowLedgesRsp>('ListKnowLedges', req);
    } catch (e) {
      logger.error('listKnowLedges e:', e);
      return {};
    }
  }

  /** 删除知识库 */
  public async deleteKnowledge(req: IDeleteKnowledgeReq): Promise<IDeleteKnowledgeRsp> {
    try {
      return await this.trpcPost<IDeleteKnowledgeRsp>('DeleteKnowledge', req);
    } catch (e) {
      logger.error('deleteKnowledge e:', e);
      return {};
    }
  }

  /** 获取知识库 */
  public async getKnowledge(req: IGetKnowledgeReq): Promise<IGetKnowledgeRsp> {
    try {
      return await this.trpcPost<IGetKnowledgeRsp>('GetKnowledge', req);
    } catch (e) {
      logger.error('getKnowledge e:', e);
      return {};
    }
  }

  /** 更新知识库 */
  public async updateKnowledge(req: IUpdateKnowledgeReq): Promise<IUpdateKnowledgeRsp> {
    try {
      return await this.trpcPost<IUpdateKnowledgeRsp>('UpdateKnowledge', req);
    } catch (e) {
      logger.error('updateKnowledge e:', e);
      return {};
    }
  }

  /** 新增文档 */
  public async addDocument(req: IAddDocumentReq): Promise<IAddDocumentRsp> {
    try {
      return await this.trpcPost<IAddDocumentRsp>('AddDocument', req);
    } catch (e) {
      logger.error('addDocument e:', e);
      return {};
    }
  }

  /** 新增文档 */
  public async updateDocument(req: IUpdateDocumentReq): Promise<IUpdateDocumentRsp> {
    try {
      return await this.trpcPost<IUpdateDocumentRsp>('UpdateDocument', req);
    } catch (e) {
      logger.error('UpdateDocument e:', e);
      return {};
    }
  }

  /** 删除文档 */
  public async deleteDocument(req: IDeleteDocumentReq): Promise<IDeleteDocumentRsp> {
    try {
      return await this.trpcPost<IDeleteDocumentRsp>('DeleteDocument', req);
    } catch (e) {
      logger.error('deleteDocument e:', e);
      return {};
    }
  }

  /** 搜索文档 */
  public async searchDocuments(req: ISearchDocumentsReq): Promise<ISearchDocumentsRsp> {
    try {
      return await this.trpcPost<ISearchDocumentsRsp>('SearchDocuments', req);
    } catch (e) {
      logger.error('searchDocuments e:', e);
      return {};
    }
  }

  /** 获取上传数据 */
  public async getUploadURL(req: IGetUploadURLReq): Promise<IGetUploadURLRsp> {
    try {
      return await this.trpcPost<IGetUploadURLRsp>('GetUploadURL', req);
    } catch (e) {
      logger.error('GetUploadURL e:', e);
      return {};
    }
  }
}

export const aiAgentServer = new AiAgentServer();

